<template>
  <div class="main-img-container">
    <div class="logo">
      <slot name="logo"></slot>
    </div>
    <img class="main-img" v-bind:src="src" alt="Main" />
    <div class="main-img-overlay"></div>
    <a href="#" v-scroll-to="scrollTo" class="scroll-down">V</a>
  </div>
</template>

<script>
export default {
  name: "MainPicture",
  props: {
    src: String,
    scrollTo: String,
    subtitle: String
  }
};
</script>

<style lang="less" scoped>
@height: 50vh;

.main-img-container {
  height: @height; //calc(100vh - 50px);
  text-align: center;

  .main-img {
    height: @height; //calc(100vh - 50px);
    width: initial;
    object-fit: cover;
    min-width: 100vw;
    max-height: calc(100vh - 50px);
    margin-left: 50%;
    transform: translateX(-50%);
  }

  .main-img-overlay {
    position: absolute;
    top: 0;
    height: @height; //calc(100vh - 50px);
    width: 100vw;
    background-color: black;
    opacity: 0.1;
    z-index: 1;
  }

  .scroll-down {
    position: relative;
    bottom: 70px;
    margin: auto;
    border: none;
    background: none;
    font-family: "Poppins", sans-serif;
    color: rgb(226, 226, 226);
    font-size: 48px;
    transform: scale(4, 2);
    text-decoration: none;
    z-index: 2;
  }

  .logo {
    position: relative;
    z-index: 3;
    height: 0;
    background-color: red;
    top: 20%;
    left: 15%;
  }

  /deep/.logo > * {
    color: white;
    font-size: 2rem;
    font-family: "Poppins", sans-serif;
  }
}

@media screen and (max-width: 768px) {
  .main-img-container .logo {
    top: 43%;
    left: 23%;
  }
}

@media print {
  img {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainPicture.vue